import { render, staticRenderFns } from "./UgiPopupPanel.vue?vue&type=template&id=a6314c9a&scoped=true&"
import script from "./UgiPopupPanel.vue?vue&type=script&lang=js&"
export * from "./UgiPopupPanel.vue?vue&type=script&lang=js&"
import style0 from "./UgiPopupPanel.vue?vue&type=style&index=0&id=a6314c9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6314c9a",
  null
  
)

export default component.exports